import axios from "axios"
import { env } from "../constants"

/* OTP: WhatsApp first, SMS fallback — channel chosen by backend */
export const request = phone => {
    const uri = `${env.startpoint}auth/otp/request`
    return axios.post(uri, { phone }).then(response => response).catch(error => error.response)
}

export const verify = (phone, code) => {
    const uri = `${env.startpoint}auth/otp/verify`
    return axios.post(uri, { phone, code }).then(response => response).catch(error => error.response)
}

/* Complete registration for new users (verify returned name_required) */
export const save = data => {
    const uri = `${env.startpoint}auth/otp/save`
    return axios.post(uri, data).then(response => response).catch(error => error.response)
}

export const resend = phone => {
    const uri = `${env.startpoint}auth/otp/resend`
    return axios.post(uri, { phone }).then(response => response).catch(error => error.response)
}

export const me = token => {
    const uri = `${env.startpoint}auth/me`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const logout = token => {
    const uri = `${env.startpoint}auth/logout`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, {}, headers).then(response => response).catch(error => error.response)
}
